'use strict';

module.exports = /* @ngInject */ function($scope, $http, apiConfig, uniteService) {

	$scope.article = null;
	$scope.articleQuantity = 1;

	$scope.init = loadBasketItem;

	$scope.checkQuantity = uniteService.checkUniteArticleQuantity;

	function loadBasketItem(articleId, articleQuantity, customerId, supplierId) {
		$scope.articleQuantity = +articleQuantity.split(',')[0];
		uniteService.getArticleById.get({
			articleId: articleId,
			supplier: supplierId,
			customer: customerId
		}).$promise.then(function(article){
			$scope.article = article;
		})
	}

}
